<template>
    <div class="jetlympic-list">
       <div class="header">
            <img src="@/assets/jetlympic/logo.png" />
       </div>
       <div class="list">
        <div class="item" v-for="item in list" :key="item.id" @click="handleItemClick(item)">
          <div class="title">{{ $t(`jetlympic.list.${item.id}`) }}</div>
        </div>
       </div>
       <img class="banner" src="@/assets/jetlympic/banner.png" />
       <div class="footer">POWER BY BMBsports</div>
    </div>
</template>

<script>
export default {
    data() {
      return {
        list: [
          {
            id: 'list_item_1', // 马拉松
            news: {
              zh: '248156',
              en: '248207'
            },
            dataPath: 'https://public.svstiming.cn/results.html?lang=zh-CN&gameid=1450',
            imagePath: 'https://www.runff.com/html/live/s5051.html'
          },
          {
            id: 'list_item_2', // 篮球
            news: {
              zh: '248162',
              en: '248197'
            },
            match: {
              zh: '57786',
              en: '58182'
            },
            imagePath: 'https://alltuu.cc/r/M7zQZ3/'
          },
          {
            id: 'list_item_3', // 足球
            news: {
              zh: '248163',
              en: '248198'
            },
            match: {
              zh: '57793',
              en: '58145'
            },
            imagePath: 'https://alltuu.cc/r/NVnU73/'
          },
          {
            id: 'list_item_4', // 羽毛球
            news: {
              zh: '248164',
              en: '248199'
            },
            match: {
              zh: '57794',
              en: '58186'
            },
            imagePath: 'https://alltuu.cc/r/iiMB7z/'
          },
          {
            id: 'list_item_5', // 乒乓球
            news: {
              zh: '248165',
              en: '248200'
            },
            match: {
              zh: '57796',
              en: '58183'
            },
            imagePath: 'https://alltuu.cc/r/iEbQbe/'
          }
        ],
        type: '',
        language: this.$i18n.locale
      };
    },
    mounted() {
      this.type = this.$route.query.type || ''
      console.log(this.language);
      
      if (this.type === 'image') { 
        document.title = '赛事图片';
      } else if (this.type === 'regulations') {
        document.title = '竞赛规程';
        const obj = {
          id: 'list_item_6', // 接力赛
          news: {
            zh: '248167',
            en: '248206'
          }
        }
        this.list.splice(1, 0, obj)
      } else if (this.type === 'data') {
        document.title = '赛事数据';
      }
    },
    methods: {
      handleItemClick(item) {
        if (this.type === 'data') {
          if (item.dataPath) {
            window.location.href = item.dataPath;
            return
          }
          if (!item.match[this.language]) {
            this.$toast('功能暂未上线，敬请期待 \n This feature is not yet \n available. ');
            return
          }
          this.$router.push({ path: `/match/home?matchId=${item.match[this.language]}` });
        } else if (this.type === 'regulations') {
          if (!item.news[this.language]) {
            this.$toast('功能暂未上线，敬请期待 \n This feature is not yet \n available. ');
            return
          }
          this.$router.push({ path: `/account/news-detail/${item.news[this.language]}` });
        }  else if(this.type === 'image') {
          window.location.href = item.imagePath;
        } else {
          this.$toast('功能暂未上线，敬请期待 \n This feature is not yet \n available. ');
        }
      }
    },
};
</script>

<style scoped lang="scss">
.jetlympic-list{
    width: 100vw;
    height: 100vh;
    background-color: #00A7FF;
    box-sizing: border-box;
    padding: 0 18px;
    .header{
        text-align: center;
        padding-top: 14px;
        img{
            width: 280px;
        }
    }
    .list{
      position: relative;
      z-index: 3;
      margin-top: 24px;
      .item{
        height: 48px;
        background-color: #fff;
        color: #00A7FF;
        text-align: center;
        line-height: 48px;
        font-size: 16px;
        font-weight: 500;
        border-radius: 3px;
        margin-bottom: 12px;
      }
    }
    .footer{
      position: absolute;
      bottom: 18px;
      width: 100%;
        text-align: center;
        color: rgba(255, 255, 255, 0.4);
        font-size: 13px;
        margin-top: 18px;
    }
    .banner{
      position: fixed;
      bottom: 0px;
      left: 0px;
      width: 100%;
      opacity: 0.6;
      z-index: 1;
    }
}
</style>
